import { lazy } from "react";

export const SETUP_ROUTES = {
  DASHBOARD: "/setup",
  USERS: "/setup/users",
  USERS_PENDING: "/setup/users/pending",
  USER_DETAIL: "/setup/users/:userId",
  PROFILE: "/setup/profile",
  STEP_1_ACCOUNT: "/setup/account/:patientId",
  STEP_2_DEVICE: "/setup/device/:patientId",
  STEP_3_VERIFY: "/setup/verify/:patientId",
  STEP_4_HANDOVER: "/setup/handover/:patientId",
  COMPLETE: "/setup/complete/:patientId",
} as const;

// Step mapping inside the setup wizard:
// /1 → Step1Account     (create patient account)
// /2 → Step2Device      (delegates to ConnectDevice in install mode)
// /3 → Step3Verify      (gated by FIELD_SETUP_VERIFY_STEP_ENABLED)
// /4 → Step4Handover    (PDF + handover instructions)
export const routes = {
  setupDashboard: {
    path: SETUP_ROUTES.DASHBOARD,
    element: lazy(() => import("../../pages/Setup/SetupDashboard")),
  },
  setupUsers: {
    path: SETUP_ROUTES.USERS,
    element: lazy(() => import("../../pages/Setup/Users")),
  },
  setupUsersPending: {
    path: SETUP_ROUTES.USERS_PENDING,
    element: lazy(() => import("../../pages/Setup/Users/PendingActivations")),
  },
  setupUserDetail: {
    path: SETUP_ROUTES.USER_DETAIL,
    element: lazy(() => import("../../pages/Setup/Users/UserDetail")),
  },
  setupProfile: {
    path: SETUP_ROUTES.PROFILE,
    element: lazy(() => import("../../pages/Setup/Profile")),
  },
  step1Account: {
    path: SETUP_ROUTES.STEP_1_ACCOUNT,
    element: lazy(() => import("../../pages/Setup/Step1Account")),
  },
  step2Device: {
    path: SETUP_ROUTES.STEP_2_DEVICE,
    element: lazy(() => import("../../pages/Setup/Step2Device")),
  },
  step3Verify: {
    path: SETUP_ROUTES.STEP_3_VERIFY,
    element: lazy(() => import("../../pages/Setup/Step3Verify")),
  },
  step4Handover: {
    path: SETUP_ROUTES.STEP_4_HANDOVER,
    element: lazy(() => import("../../pages/Setup/Step4Handover")),
  },
  setupComplete: {
    path: SETUP_ROUTES.COMPLETE,
    element: lazy(() => import("../../pages/Setup/Complete")),
  },
  catchAll: {
    path: "*",
    element: lazy(() => import("./CatchAllRedirect")),
  },
} as const;
